import { useCheckRole, useListUserProfile, useMyHubsList } from "hooks";
import React, { useEffect, useMemo, useState } from "react";

const useUserList = () => {
  const { data: myHubs, refetch: refetchMyHubs } = useMyHubsList();
  const { isHubAdmin, isLogAdmin } = useCheckRole();
  const [userProfileParams, setUserProfileParams] = useState({
    sizePerPage: 10,
    page: -1,
    sort: "-maker_date",
    columnFilter: {
      "filter[user_type][in]": [1, 4],
      "filter[record_status]": "O",
    },
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
    run: false,
  });

  const { data: userProfileList, refetch: listUserProfile } =
    useListUserProfile({ params: userProfileParams });

  const optionUserScan = useMemo(() => {
    if (userProfileList) {
      return userProfileList.items
        .filter(item => item.code)
        .map(item => {
          return {
            label: item.display_name,
            value: item.code,
          };
        });
    }
    return [];
  }, [userProfileList]);
  useEffect(() => {
    refetchMyHubs();
  }, []);

  useEffect(() => {
    if (myHubs) {
      if (isHubAdmin) {
        setUserProfileParams(prev => ({
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            "filter[user_type][in]": [4],
            hub_id: myHubs.hub.id,
          },
          run: true,
        }));
      } else {
        const hubId = myHubs?.hub?.id ?? null;
        const listChildHub = Array.isArray(myHubs?.childs_hub)
          ? myHubs.childs_hub.map(h => h.id)
          : [];
        const listHubCenter = hubId ? [hubId, ...listChildHub] : listChildHub;

        setUserProfileParams(prev => ({
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            "filter[user_type][in]": [1, 4],
            hub_id: listHubCenter.join(","),
          },
          run: true,
        }));
      }
    }
  }, [isHubAdmin, myHubs]);
  useEffect(() => {
    if (userProfileParams.run) {
      listUserProfile();
    }
  }, [userProfileParams]);

  return {
    optionUserScan,
    myHubs,
    isHubAdmin,
    isLogAdmin,
  };
};

export default useUserList;
